(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-scroll-reveal]';

    function initSection(section) {
      if (!section || section.__srInited) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      if (!window.gsap || !window.ScrollTrigger) return;

      window.gsap.registerPlugin(window.ScrollTrigger);

      var img = section.querySelector('[data-reveal-img]');
      var text = section.querySelector('[data-reveal-text]');
      if (!img) return;

      var startScale = parseFloat(section.dataset.startScale) || 3.75;
      var startRot = parseFloat(section.dataset.startRotation) || 90;
      var ox = parseFloat(section.dataset.originX);
      var oy = parseFloat(section.dataset.originY);
      var pinDesktop = parseFloat(section.dataset.pinDesktop) || 150;
      var pinMobile = parseFloat(section.dataset.pinMobile) || 100;
      var endHold = parseFloat(section.dataset.endHold);
      if (isNaN(endHold)) endHold = 30;

      // Timeline math: reveal + text finish by revealEnd fraction of the scrub,
      // then hold the resolved state for the remainder before pin releases.
      var revealEnd = Math.max(0.1, 1 - (endHold / 100));
      var textStart = Math.max(0, revealEnd - 0.15);

      var tl = window.gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          // Functional end: re-evaluated on every ScrollTrigger.refresh(), so the
          // pin length tracks the *live* viewport after late layout (fonts/images/
          // the FAQ accordion above). This alone keeps the pin-spacer correct —
          // it does NOT need invalidateOnRefresh, which would (harmfully) re-read
          // the tween's start values from the image's *current* transform on every
          // refresh and break the "starts fully zoomed" state mid-scroll.
          end: function () {
            var mobile = window.matchMedia('(max-width: 749px)').matches;
            return '+=' + (mobile ? pinMobile : pinDesktop) + '%';
          },
          pin: true,
          scrub: true,
          anticipatePin: 1,
          onEnter: function () { section.classList.add('scroll-reveal--active'); },
          onEnterBack: function () { section.classList.add('scroll-reveal--active'); },
          onLeave: function () { section.classList.remove('scroll-reveal--active'); },
          onLeaveBack: function () { section.classList.remove('scroll-reveal--active'); }
        }
      });

      // fromTo (not a one-off gsap.set + to): the start values live in the tween,
      // so they're re-applied verbatim on every refresh — the reveal always begins
      // fully zoomed + rotated, no flash / wrong-start regardless of when a refresh
      // fires relative to scroll position.
      tl.fromTo(img, {
        scale: startScale,
        rotation: startRot,
        transformOrigin: ox + '% ' + oy + '%'
      }, {
        scale: 1,
        rotation: 0,
        ease: 'none',
        duration: revealEnd
      }, 0);

      if (text) {
        tl.fromTo(text, {
          opacity: 0
        }, {
          opacity: 1,
          ease: 'none',
          duration: revealEnd - textStart
        }, textStart);
      }

      // Hold: empty duration so the pin stays engaged after the reveal resolves.
      tl.to({}, { duration: 1 - revealEnd }, revealEnd);

      // Image is lazy-loaded — recompute pin geometry once it's actually sized.
      if (img.complete) {
        window.ScrollTrigger.refresh();
      } else {
        img.addEventListener('load', function () {
          window.ScrollTrigger.refresh();
        }, { once: true });
      }

      section.__srInited = true;
      section.__srTl = tl;
    }

    function killSection(section) {
      if (!section || !section.__srTl) return;
      var st = section.__srTl.scrollTrigger;
      if (st) st.kill();
      section.__srTl.kill();
      section.__srInited = false;
      section.__srTl = null;
      section.classList.remove('scroll-reveal--active');
    }

    function initAll() {
      document.querySelectorAll(SELECTOR).forEach(initSection);
    }

    function waitForGsap(cb, attempts) {
      attempts = attempts || 0;
      if (window.gsap && window.ScrollTrigger) { cb(); return; }
      if (attempts > 50) return; // ~5s
      setTimeout(function () { waitForGsap(cb, attempts + 1); }, 100);
    }

    function refreshWhenReady() {
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { waitForGsap(initAll); });
    } else {
      waitForGsap(initAll);
    }

    // Late layout (images finishing, web-font swap, the FAQ accordion above)
    // changes the document height after init and leaves the pin-spacer stale —
    // which is what makes the pinned section overlap its neighbours. Recompute
    // once those settle. ScrollTrigger already refreshes itself on resize.
    window.addEventListener('load', function () { waitForGsap(refreshWhenReady); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { waitForGsap(refreshWhenReady); });
    }

    // Ongoing (not just initial) height changes leave the pin-spacer + trigger
    // start/end stale — which makes the pinned reveal overlap its neighbours AND
    // start at the wrong scroll progress (a flash of the resolved image). Debounce
    // so a burst of changes recomputes geometry once.
    var srRefreshTimer;
    function srDebouncedRefresh() {
      clearTimeout(srRefreshTimer);
      srRefreshTimer = setTimeout(function () { waitForGsap(refreshWhenReady); }, 150);
    }

    // The homepage FAQ above this section is native <details> accordions; opening/
    // closing one changes document height. `toggle` does NOT bubble, so a
    // document-level listener must run in the capture phase to receive it.
    // (Deliberately NOT a ResizeObserver on document.body — pinning mutates body
    // height itself, so that would refresh on its own pin-spacer changes and thrash
    // the scrub. The toggle listener only fires on real user FAQ interaction.)
    document.addEventListener('toggle', srDebouncedRefresh, true);

    // Shopify theme editor: re-init on section load/unload so live edits work.
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector(SELECTOR) || (e.target.matches && e.target.matches(SELECTOR) ? e.target : null);
      if (section) waitForGsap(function () { initSection(section); });
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var section = e.target.querySelector(SELECTOR) || (e.target.matches && e.target.matches(SELECTOR) ? e.target : null);
      if (section) killSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
